exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/category/category.component.css
// module id = ../../../../../src/app/category/category.component.css
// module chunks = main